import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';

const GuidedFlowCard = ({ title, description, badge, onClick, gradient }) => {
  const { t } = useTranslation('homepage');
  return (
    <Card
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        height: '200px',
        background: gradient || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: '0 12px 24px rgba(0,0,0,0.3)'
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 100%)',
          zIndex: 1
        }
      }}
    >
      <CardContent sx={{ position: 'relative', zIndex: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box>
          {badge && (
            <Chip 
              label={badge} 
              size="small" 
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.2)', 
                color: 'white',
                fontWeight: 'bold',
                mb: 2
              }} 
            />
          )}
        </Box>
        
        <Box>
          <Typography sx={{ paddingLeft: '5vw', paddingRight: '5vw' }} variant="h5" component="h2" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>
            {description}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
              {t('guidedFlow.startNow')}
            </Typography>
            <ArrowForwardIcon fontSize="small" />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GuidedFlowCard;
